import {buttonVariants} from '@/components/app/button';
import {useLocation} from 'react-router-dom';
import {InfoSection} from '../../../../app/components/InfoSection';
import {ErrorComponentProps} from '../../type';
export const Error0028 = (props: ErrorComponentProps) => {
  const location = useLocation();
  return (
    <InfoSection
      {...props}
      actions={[
        {
          props: {
            className: buttonVariants({className: 'rounded-full hover:no-underline'}),
            children: 'Sign Up',
            to: '/sign-up',
          },
          type: 'link',
        },
      ]}
      message={location.state?.message ?? 'Error'}
    />
  );
};
